<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item>
						<template>
							<el-form-item label="省分类名称:" class='tiny' cleartable>
								<el-input style="width: 200px;" v-model="searchInfo.className" placeholder="请输入省分类名称"></el-input>
							</el-form-item>
							<el-button type="primary" @click="search">搜索</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="editialogVisible('',1)">新增省
							</el-button>
							<el-button type="primary" @click="editialogVisible('',2)">新增市
							</el-button>
							<el-button type="primary" @click="editialogVisible('',3)">新增区
							</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>


		<el-table :data="goodsClassList.list" style="width: 100%" row-key="id" :header-cell-style="headClass" border lazy
			:tree-props="{children: 'children', hasChildren: 'hasChildren'}" v-loading="loading" element-loading-text="拼命加载中">

			<el-table-column prop="orderIndex" label="排序级别" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="name" label="名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="id" label="ID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="pid" label="PID" align="center" :show-overflow-tooltip="true">
			</el-table-column>


			<el-table-column  label="操作"  fixed="right" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row,'')">编辑</el-button>
					<el-button size="small" type="text" @click="deltialogVisible(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="goodsClassList.pageNum" @current-change="pageChange"
			layout="total, sizes, prev, pager, next, jumper" :total="goodsClassList.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 查看 -->
		<el-dialog :closeOnClickModal="false" title="提示" :visible.sync="showContentDialog" width="50%">
			<span v-html="contentValue"></span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 编辑和添加 -->
		<el-dialog style="float:rigin" :title="title" :visible.sync="editDialogVisible" width="50%"
			:closeOnClickModal="false">
			<div class="app-container">
				<el-form ref="form" :model="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">

					<el-form-item  label="省:" v-if="form.level>=2">
						<el-select clearable v-model="classGoods1Id" placeholder="请选择省" style="width:200px;margin-right:10px;"
							@change="classGoods1">
							<el-option clearable v-for="item in provinceList" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item v-if="form.level==3" label="市:">
						<el-select clearable v-model="classGoods2Id" placeholder="请选择市" style="width:200px;margin-right:10px;"
							@change="classGoods2">
							<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
                    <el-form-item v-if="form.level==1" label="省:">
						<el-input v-model="form.name" style="width: 260px;" placeholder="请输入名称" />
					</el-form-item>
                    <el-form-item v-if="form.level==2" label="市:">
						<el-input v-model="form.name" style="width: 260px;" placeholder="请输入名称" />
					</el-form-item>

					<el-form-item v-if="form.level==3" label="区:">
						<el-input v-model="form.name" style="width: 260px;" placeholder="请输入名称" />
					</el-form-item>

					<el-form-item>
						<el-button :loading="loading" type="primary" @click="toEdit()">提交</el-button>
						<el-button @click="editDialogVisible = false">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false">
			<div style="text-align: center;">
				<img width="100%" class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="">
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('address');

	import {
		quillEditor
	} from 'vue-quill-editor' //调用编辑器
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				title: "",
				classGoods1Id: 0,
				classGoods2Id: 0,
				provinceList: [], //省
                cityList: [], //市
				imgUrl: urls,
				dialogVisibleImg: false,
				dialogImageUrl: '',
				fileList: [],
				loading: false,
				goodsClassList: [], //商品分类列表
				dialogVisible: false,
				editDialogVisible: false,
				form: {
					id: 0,
					name: "",
					level: "",
					orderIndex: 0,
					pid: 0
				},
				costpricerate:'0.06',
				mainFormRules: {
					title: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
				},
				integralList: [],
				formLabelWidth: "200px",
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {},
				index: null,
				contentValue: "",
				showContentDialog: false,
				tableDataList:[ ]
			};
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			}
		},
		methods: {
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					pid: 0,
					name: this.searchInfo.className
				}
				this.$api.getAreaList(data).then((res) => { //商品分类列表
					console.log(res);
					if (res.state == 'success') {
						this.goodsClassList = res.data
						this.loading = false
					} else {
						this.$message.error(res.message);
					}
				})
			},
			//选中一级分类
			classGoods1(e) {
				this.classGoods2Id = "";
				if (e) {
					if (this.form.level != 3) {
						this.form.level = 2;
						this.form.pid = e;
					}

					this.$api.getProvinceList(e).then((res) => { //根据省id查询市
						if (res.state == 'success') {
							this.cityList = res.data;
						}
					})
				}
			},
			//选中二级分类
			classGoods2(e) {
				if (e) {
					this.form.pid = e;
					this.form.level = 3;
				}
				console.log(e)
				console.log(this.form.pid)

			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			handleRemove(file, fileList) {
				//console.log(file, fileList);
			},
			handlePreview(file) {
				//console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			onSuccess(response, file, fileList) {
				console.log(response);
				var form = {
					id: this.form.id,
					name: this.form.name,
					level: this.form.level,
					orderIndex: this.form.orderIndex,
					pid: this.form.pid
				}
				this.form = form;
			},
			showContent(content) {
				this.contentValue = content
				this.showContentDialog = true
			},
			//编辑弹框
			editialogVisible(row, level) {
                console.log('点击--',row)
				this.fileList = []

				//下拉框赋空值
				this.classGoods1Id = "";
				this.classGoods2Id = "";
				this.cityList = [];
				// this.tableDataList = []
				this.tableDataList.map(item=>{
					item.agreementPriceAddRate = ''
				})
				this.form = {
					id: null,
					name: '',
					level: "",
					orderIndex: 0,
					pid: 0
				};

				if (row) {
					this.title = '编辑';
					this.fileList = []
					//编辑查询
					this.ids = row.id
					// this.form.timer = []
					this.$api.getAreaById(row.id).then((res) => { //
						if (res.state == 'success') {
                            this.form = res.data;
							if (res.data.level == 2) {//二级分类
								this.classGoods1Id = res.data.pid;
							} else if (res.data.level == 3) {//三级分类
                                this.classGoods2Id = res.data.pid;

								this.$api.getAreaById(res.data.pid).then((res) => {
									if (res.state == 'success') {
                                        this.classGoods1Id = res.data.pid;
                                        
										this.$api.getProvinceList(res.data.pid).then((res) => { //省
											if (res.state == 'success') {
                                                this.cityList = res.data;
											}
										})
									} else {
										this.$message.error(res.message);
									}
								})


							}

						}
					})
				} else {
					this.ids = ""
				}

				if (level) {
					this.form.level = level;
					if (level == 1) {
						this.title = '添加省';
					} else if (level == 2) {
						this.title = '添加市';
					} else if (level == 3) {
						this.title = '添加区';
					}
				}

				this.editDialogVisible = true;
			},
			
			deltialogVisible(item){
				// let data={
				// 	id:item.id
				// }
				this.$api.deltArea(item.id).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false;
                        this.findGoodsClassInfo(); //分类列表刷新
                        this.queryAreaList();
					} else {
						this.$message.error(res.data);
					}
				})
			},
			toEdit() {
				if (this.ids) {
                    //编辑
                    console.log('编辑接口--',this.form)
					this.$api.updateArea(this.form).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
                            this.findGoodsClassInfo(); //分类列表刷新
                            this.queryAreaList();
						} else {
							this.$message.error(res.message);
						}
					})
				} else {
					//添加
					this.loading = true
					console.log('122--',this.tableDataList);
					console.log('133--',this.form.pid)
					console.log('144--',this.form)
					this.$api.addArea({...this.form,tableDataList:this.tableDataList}).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
                            this.findGoodsClassInfo();
                            this.queryAreaList();
						} else {
							this.$message.error(res.message);
						}
						this.loading = false
					})
				}
			},
			pageChange(data) {
				this.page.pageNum = data
                this.findGoodsClassInfo();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findGoodsClassInfo()
			},
			findGoodsClassInfo() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
                    // level: 1
                    pid: 0
				}
				this.$api.getAreaList(data).then((res) => { //商品分类列表
					console.log('数据--',res);
					if (res.state == 'success') {
						this.goodsClassList = res.data
						this.loading = false
					} else {
						this.$message.error(res.message);
					}
				})
			},
			goodsClassfindByPid(row, expanded) {
				console.log(row, expanded);
				//this.loading2 = true
				this.$api.getAreaById({id:row.id}).then((res) => { //根据pid查询商品分类
					console.log(res);
					if (res.state == 'success') {
						this.goodsClassList2 = res.data
						//this.loading2 = false
					} else {
						this.$message.error(res.message);
					}
				})
            },
            queryAreaList(){
                this.$api.getProvinceList(0).then((res) => { //查询所有省
                    if (res.state == 'success') {
                        this.provinceList = res.data;
                        console.log('所有省--',res.data)
                    }
                })
            }
		},
		created() {
			this.findGoodsClassInfo();
			this.queryAreaList();
			// this.$api.findRate().then(res=>{
			// 	if(res.state == 'success'){
			// 		this.tableDataList = res.data
			// 		console.log(this.tableDataList);
			// 	}
			// })
		},
		mounted: function () { },
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}
</style>